var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h1',[_vm._v(" 404 Not Found ")]),_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])])}]

export { render, staticRenderFns }